const defaultComponentState = {
    hover: !1,
    press: !1,
    pressIn: !1,
    focus: !1,
    focusVisible: !1,
    focusWithin: !1,
    unmounted: !0,
    disabled: !1
  },
  defaultComponentStateMounted = {
    ...defaultComponentState,
    unmounted: !1
  },
  defaultComponentStateShouldEnter = {
    ...defaultComponentState,
    unmounted: "should-enter"
  };
export { defaultComponentState, defaultComponentStateMounted, defaultComponentStateShouldEnter };
//# sourceMappingURL=defaultComponentState.mjs.map
